var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarMaterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 14,
    r: 8.5,
    stroke: "url(#paint0_linear_3591_14574)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 14,
    r: 12.25,
    stroke: "url(#paint1_linear_3591_14574)",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.951 18.4736L13.6856 18.9999H13.2324L13.4979 18.4736H13.951Z",
    fill: "url(#paint2_linear_3591_14574)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8833 18.4736L14.6114 18.9999H14.1582L14.4301 18.4736H14.8833Z",
    fill: "url(#paint3_linear_3591_14574)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8149 18.4736L15.543 18.9999H15.0898L15.3617 18.4736H15.8149Z",
    fill: "url(#paint4_linear_3591_14574)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4823 17.1465L16.2168 17.6802H15.7637L16.0291 17.1465H16.4823Z",
    fill: "url(#paint5_linear_3591_14574)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1421 15.8271L16.8702 16.3535H16.417L16.6889 15.8271H17.1421Z",
    fill: "url(#paint6_linear_3591_14574)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5497 17.1465L15.2842 17.6802H14.8311L15.0965 17.1465H15.5497Z",
    fill: "url(#paint7_linear_3591_14574)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0488 9.52632L20.3207 9H20.7739L20.502 9.52632H20.0488Z",
    fill: "url(#paint8_linear_3591_14574)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1172 9.52632L19.3891 9H19.8423L19.5704 9.52632H19.1172Z",
    fill: "url(#paint9_linear_3591_14574)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1914 9.52632L18.4568 9H18.91L18.6381 9.52632H18.1914Z",
    fill: "url(#paint10_linear_3591_14574)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5176 10.8531L17.7895 10.3193H18.2427L17.9708 10.8531H17.5176Z",
    fill: "url(#paint11_linear_3591_14574)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8643 12.1728L17.1297 11.6465H17.5829L17.3174 12.1728H16.8643Z",
    fill: "url(#paint12_linear_3591_14574)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4502 10.8531L18.7221 10.3193H19.1753L18.9034 10.8531H18.4502Z",
    fill: "url(#paint13_linear_3591_14574)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0949 18.066C20.7358 18.066 20.6452 19 20.0949 19H16.0293L16.2947 18.4663H16.8709L17.0975 18.0586L20.0949 18.066Z",
    fill: "url(#paint14_linear_3591_14574)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6155 16.7393C22.2499 16.7393 22.1852 17.6733 21.6155 17.6733H16.6953L16.9607 17.1396H17.8477L18.0484 16.7393H21.6155Z",
    fill: "url(#paint15_linear_3591_14574)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5485 15.4199C23.183 15.4199 23.1182 16.3539 22.5485 16.3539H17.3564L17.6219 15.8202H18.9749L19.1756 15.4199H22.5485Z",
    fill: "url(#paint16_linear_3591_14574)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7311 14.3004C13.2132 14.3004 13.1291 15.2418 13.7311 15.2344H15.3043L15.5244 14.8193H17.6349L17.8938 14.293L13.7311 14.3004Z",
    fill: "url(#paint17_linear_3591_14574)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6549 14.8338C22.2634 14.8264 22.1663 13.9146 21.6484 13.9072H19.389L19.1883 14.3001H18.405L18.1201 14.8338H21.6549Z",
    fill: "url(#paint18_linear_3591_14574)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3519 12.9659H16.916L16.6311 13.4922H14.8184L14.5983 13.9073H12.3519C11.7563 13.9147 11.8146 12.9585 12.3519 12.9659Z",
    fill: "url(#paint19_linear_3591_14574)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0877 13.4999C20.6769 13.4924 20.6121 12.5732 20.0813 12.5732H18.5016L18.3009 12.9661H17.3816L17.1162 13.4999H20.0877Z",
    fill: "url(#paint20_linear_3591_14574)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4519 12.5801C10.8174 12.5801 10.8822 11.6387 11.4519 11.6387H16.6439L16.372 12.1724H15.0255L14.8183 12.5801H11.4519Z",
    fill: "url(#paint21_linear_3591_14574)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3845 11.2608C11.7501 11.2608 11.8148 10.3193 12.3845 10.3193H17.3111L17.0457 10.8531H16.1523L15.9516 11.2608H12.3845Z",
    fill: "url(#paint22_linear_3591_14574)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9054 9.93403C13.2644 9.93403 13.3551 9 13.9054 9H17.971L17.7055 9.53373H17.1294L16.9028 9.93403H13.9054Z",
    fill: "url(#paint23_linear_3591_14574)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68334 24.863C8.02688 25.4071 7 26.1636 7 27C7 28.6569 11.0294 30 16 30C20.9706 30 25 28.6569 25 27C25 26.1636 23.9731 25.4071 22.3167 24.863",
    stroke: "url(#paint24_linear_3591_14574)",
    strokeWidth: 1.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 31C2.72296 29.8808 1 28.3213 1 26.5963C1 24.77 2.93125 23.1291 6 22M26.5 31C29.277 29.8808 31 28.3213 31 26.5963C31 24.77 29.0687 23.1291 26 22",
    stroke: "url(#paint25_linear_3591_14574)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3591_14574",
    x1: 8,
    y1: 24.9286,
    x2: 28.0749,
    y2: 20.4831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#7DA1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645919,
    stopColor: "#E16CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999152,
    stopColor: "#E65B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3591_14574",
    x1: 3,
    y1: 29.7857,
    x2: 31.9971,
    y2: 23.3644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#7DA1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645919,
    stopColor: "#E16CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999152,
    stopColor: "#E65B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3591_14574",
    x1: 13.3632,
    y1: 18.7109,
    x2: 13.8163,
    y2: 18.7109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#845D78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#815A70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3591_14574",
    x1: 14.302,
    y1: 18.7109,
    x2: 14.7875,
    y2: 18.7109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#916589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A66492"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3591_14574",
    x1: 15.2401,
    y1: 18.7109,
    x2: 15.6932,
    y2: 18.7109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA678C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6384"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3591_14574",
    x1: 15.888,
    y1: 17.3763,
    x2: 16.3411,
    y2: 17.3763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A988A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4839E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3591_14574",
    x1: 16.5996,
    y1: 16.0051,
    x2: 16.9935,
    y2: 16.0911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C793B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C29BB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3591_14574",
    x1: 14.9813,
    y1: 17.3763,
    x2: 15.4344,
    y2: 17.3763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7E99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#967590"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3591_14574",
    x1: 20.1926,
    y1: 9.22239,
    x2: 20.7105,
    y2: 9.22239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CAEB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AABABD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3591_14574",
    x1: 19.2869,
    y1: 9.11119,
    x2: 19.721,
    y2: 9.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0D1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AB1B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3591_14574",
    x1: 18.3157,
    y1: 9.22239,
    x2: 18.8012,
    y2: 9.22239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74ACAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3591_14574",
    x1: 17.6678,
    y1: 10.5566,
    x2: 18.121,
    y2: 10.5566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C6D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACBAC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3591_14574",
    x1: 17.0209,
    y1: 11.8911,
    x2: 17.4741,
    y2: 11.8911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA9BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC6DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3591_14574",
    x1: 18.6069,
    y1: 10.5566,
    x2: 19.06,
    y2: 10.5566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84BAB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FC2C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3591_14574",
    x1: 16.2766,
    y1: 18.5627,
    x2: 20.517,
    y2: 18.5627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF9BE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C570A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3591_14574",
    x1: 16.9232,
    y1: 17.2285,
    x2: 22.2641,
    y2: 17.2285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8CB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426554,
    stopColor: "#DF9EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BEE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3591_14574",
    x1: 17.539,
    y1: 15.8944,
    x2: 22.7829,
    y2: 15.8944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF9EBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41C9ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3591_14574",
    x1: 13.331,
    y1: 14.7822,
    x2: 17.5714,
    y2: 14.7822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B5D8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#DC6DB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B597B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3591_14574",
    x1: 18.2832,
    y1: 14.4855,
    x2: 22.1678,
    y2: 14.4289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5B4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48D8FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3591_14574",
    x1: 11.9065,
    y1: 13.4477,
    x2: 16.762,
    y2: 13.4477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA58A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A8CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3591_14574",
    x1: 17.2793,
    y1: 13.0032,
    x2: 20.5163,
    y2: 13.0032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4ACCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C1F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3591_14574",
    x1: 11,
    y1: 12.1131,
    x2: 16.3733,
    y2: 12.1131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF5AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D391C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3591_14574",
    x1: 11.9067,
    y1: 10.779,
    x2: 17.28,
    y2: 10.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D077AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FE93D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7B2C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3591_14574",
    x1: 13.4599,
    y1: 9.44477,
    x2: 17.9916,
    y2: 9.44477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#B7A2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FBBC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3591_14574",
    x1: 7,
    y1: 24.3126,
    x2: 20.1449,
    y2: 34.5124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#7DA1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645919,
    stopColor: "#E16CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999152,
    stopColor: "#E65B8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3591_14574",
    x1: 1,
    y1: 21.0357,
    x2: 23.7197,
    y2: 37.8063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#7DA1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645919,
    stopColor: "#E16CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999152,
    stopColor: "#E65B8B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarMaterial);
export default __webpack_public_path__ + "static/media/avatar-material.aa2cdcce1f6f34deaa5d9314c9e44a5f.svg";
export { ForwardRef as ReactComponent };